import { IKnmPreview } from 'ApiPackage/SearchModule/interfaces/IKnmPreview';

import { parseErknmValue } from '../common/parseErknmValue';
import { KnmSubtitle } from './KnmSubtitle';
import styles from './styles.module.scss';

interface IPmControlProps {
  passportData?: IKnmPreview;
}

export const PmControl = ({ passportData }: IPmControlProps) => {
  const supervisionType = passportData?.pmErknm?.supervisionType?.value
    ? parseErknmValue<{
        number?: string;
        title?: string;
        shortTitle?: string | null;
        selectedLabel?: string;
      }>(passportData?.pmErknm.supervisionType.value)
    : undefined;
  const knoOrganization = passportData?.pmErknm?.knoOrganization?.value
    ? parseErknmValue<{
        fullName?: string | null;
      }>(passportData?.pmErknm.knoOrganization.value)
    : undefined;

  const supervisionTypeLabel = () => {
    if (!supervisionType) {
      return '';
    }

    if (passportData?.transferred && passportData?.transferringAuthorities) {
      const ervkTransferringTitles = passportData.transferringAuthorities
        .filter(x => x.title !== undefined && x.title !== null)
        .map(x => x.title);
      const ervkTransferringShortTitles = passportData.transferringAuthorities
        .filter(x => x.shortTitle !== undefined && x.shortTitle !== null)
        .map(x => x.shortTitle);

      if (ervkTransferringShortTitles.length) {
        return `${supervisionType.number} - ${
          passportData?.pmErknm?.supervisionType?.title || supervisionType.title
        } - передано от ${ervkTransferringShortTitles.join(', ')}`;
      }
      if (ervkTransferringTitles.length) {
        return `${supervisionType.number} - ${
          passportData?.pmErknm?.supervisionType?.title || supervisionType.title
        } - передано от ${ervkTransferringTitles.join(', ')}`;
      }
    }

    return `${supervisionType.number} - ${passportData?.pmErknm?.supervisionType?.title || supervisionType.title}`;
  };

  const knoOrganizationLabel = () => {
    if (!knoOrganization) {
      return '';
    }

    return passportData?.pmErknm?.knoOrganization?.title || knoOrganization.fullName;
  };

  return (
    <div className={styles.ColumnContent}>
      <KnmSubtitle title="Контрольный (надзорный) орган">
        {passportData?.pmErknm.knoOrganization && passportData?.pmErknm.knoOrganization.value && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Наименование органа контроля</div>
            <div className={styles.ColValue}>{knoOrganizationLabel()}</div>
          </div>
        )}
        {passportData?.pmErknm?.supervisionType?.value && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Вид контроля (надзора) и его номер</div>
            <div className={styles.ColValue}>{`${supervisionTypeLabel()}`}</div>
          </div>
        )}
      </KnmSubtitle>
    </div>
  );
};
